import { Loader2 } from "lucide-react";

export default function GenerationProgress({
  active = false,
  message = "",
  hint = "",
  className = "",
}) {
  if (!active) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border border-consensus-500/25 bg-consensus-500/10 px-3 py-2.5 text-sm ${className}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-4 w-4 animate-spin text-consensus-300 shrink-0 mt-0.5" />
      <div className="min-w-0">
        <p className="text-consensus-200 font-medium">
          {message || "Working…"}
        </p>
        {hint && <p className="text-white/45 text-xs mt-1">{hint}</p>}
      </div>
    </div>
  );
}
